import { BOTTONSHEET_PHONE_ENROLLMENT } from '@root/constants';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import { onClickSecondaryPhonNoBottomSheet } from '@utils/utils';

// Define interfaces for function parameters
interface InfoModal {
  selectedNumber: string;
  selectedName: string;
  errorCode: string;
  currentId: number;
  visible: boolean;
  data: {
    hasTwoButtons: boolean;
  };
}

interface BottomSheetHandlers {
  onPressPrimaryBottomSHeet: () => void;
  onPressSecondaryBottomSheet: () => void;
  onBottomSheetCloseHandler: () => void;
}

export function onDeletePhoneCompleteCallBack(
  infoModal: InfoModal,
  getPhoneNumbers: () => void,
  setInfoModal: (state: InfoModal) => void,
  initalState: InfoModal,
): void {
  const e = AMPLITUDE_CONSTANTS.PhoneEnroll.phonenumber_delete_confirmed;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.number]: infoModal.selectedNumber,
    [e.attributes.name]: infoModal.selectedName,
  });
  getPhoneNumbers();
  setInfoModal(initalState);
}

export function getBottomSheetHandlers(
  infoModal: InfoModal,
  setInfoModal: (state: InfoModal) => void,
  deletePhoneNumber: (payload: unknown) => void,
  initalState: InfoModal,
): BottomSheetHandlers {
  const onPressPrimaryBottomSHeet = (): void => {
    if (infoModal.errorCode === BOTTONSHEET_PHONE_ENROLLMENT.PHONE_DELETE) {
      onClickSecondaryPhonNoBottomSheet(
        setInfoModal,
        infoModal,
        deletePhoneNumber,
        infoModal.currentId,
        BOTTONSHEET_PHONE_ENROLLMENT,
      );
    } else {
      setInfoModal(initalState);
    }
  };

  const onPressSecondaryBottomSheet = (): void => {
    if (infoModal.errorCode === BOTTONSHEET_PHONE_ENROLLMENT.PHONE_DELETE) {
      const e = AMPLITUDE_CONSTANTS.PhoneEnroll.phonenumber_delete_cancelled;
      AmplitudeHelper.logEvent(e.name, {
        [e.attributes.number]: infoModal.selectedNumber,
        [e.attributes.name]: infoModal.selectedName,
        [e.attributes.button]: 'cancel',
      });
    }
    setInfoModal(initalState);
  };

  const onBottomSheetCloseHandler = (): void => {
    if (infoModal.errorCode === BOTTONSHEET_PHONE_ENROLLMENT.PHONE_DELETE) {
      const e = AMPLITUDE_CONSTANTS.PhoneEnroll.phonenumber_delete_cancelled;
      AmplitudeHelper.logEvent(e.name, {
        [e.attributes.number]: infoModal.selectedNumber,
        [e.attributes.name]: infoModal.selectedName,
        [e.attributes.button]: 'close',
      });
    }
    setInfoModal(initalState);
  };

  return { onPressPrimaryBottomSHeet, onPressSecondaryBottomSheet, onBottomSheetCloseHandler };
}

export function shouldShowFooterComponent(
  isTransact: boolean,
  footerComponent: () => JSX.Element | null,
): JSX.Element | null {
  return isTransact ? null : footerComponent();
}
